<template>
  <b-container>
    <b-col lg="12" class="w-100">
      <m-single-lesson-1 class="ml-auto mt-5 mr-auto"/>
    </b-col>
  </b-container>
</template>

<script>

export default {
  name: "SingleLesson",
}
</script>
